import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingCart, ArrowRight, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { money } from "@/lib/helpers";

export const PackageBar = () => {
  const { pkg, clearPkg, lang } = useApp();
  const loc = useLocation();
  if (!pkg.length || loc.pathname === "/paquete") return null;
  const total = pkg.reduce((s, p) => s + (p.price || 0) * (p.participants || 1), 0);

  return (
    <div data-testid="package-bar"
      className="fixed bottom-[86px] left-3 right-3 sm:bottom-6 sm:left-auto sm:right-6 sm:w-[360px] z-[55] flex items-stretch gap-1 rounded-2xl bg-[#16221D] text-white shadow-[0_18px_45px_rgb(0,0,0,0.35)] overflow-hidden">
      <Link to="/paquete" data-testid="package-bar-link"
        className="flex-1 min-w-0 flex items-center gap-3 px-4 py-3.5 hover:bg-[#243A2F] transition-colors duration-300">
        <ShoppingCart className="h-5 w-5 text-[#F0C674] shrink-0" />        <span className="flex-1 min-w-0">
          <span className="block text-sm font-semibold" data-testid="package-bar-count">
            {pkg.length} {lang === "es" ? (pkg.length === 1 ? "salida en tu carrito" : "salidas en tu carrito") : "departures in your cart"}
          </span>
          <span className="block text-xs text-white/70 truncate">
            {money(total)} MXN · {lang === "es" ? "Ver mi carrito" : "View my cart"}
          </span>
        </span>
        <ArrowRight className="h-4 w-4 shrink-0" />
      </Link>
      <button data-testid="package-bar-clear"
        aria-label={lang === "es" ? "Vaciar mi carrito" : "Clear my cart"}
        onClick={clearPkg}
        className="px-3 border-l border-white/15 text-white/60 hover:text-white hover:bg-[#243A2F] transition-colors duration-300">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
